import "./TwoFactorAuthActivation.css";
import { TwoFactorAuth } from './TwoFactorAuth';
import { useContext, useState } from "react";
import { LocaleContext, LoginContext, StateContext } from "./App";
import { postWithCsrf } from "./util";
import { LoadState, TwoFactorAuthType } from "./enums.mjs";
import { Navigate } from "react-router-dom";
import { NavigateSmart } from "./Common";

export function TwoFactorAuthActivation(props) {
    const state = useContext(StateContext);
    const locale = useContext(LocaleContext);
    const login = useContext(LoginContext);

    const [errorText, setErrorText] = useState("");
    const [loadState, setLoadState] = useState(LoadState.NONE);

    function handle2faCodeEntered(code) {
        try {
            const obj = {
                two_factor_code: code,
                two_factor_auth_type: props.twoFactorType
            };

            postWithCsrf("/user/enable_two_factor_auth", JSON.stringify(obj), state).then(response => {
                setLoadState(LoadState.LOAD_SUCCESS);

                if(response.ok) {
                    return response.json();
                }

                throw new Error("Response code: " + response.status);
            }).then((json) => {
                login.setTwoFactorAuthEnabled(true);
                props.onAuthenticated();
                login.setDisplayRememberDevice(true);
                login.setTwoFactorAuthMobileNo(json.two_factor_auth_mobile_no);
            }).catch(error => {
                setLoadState(LoadState.LOAD_ERROR);

                console.log(error);
                setErrorText(<div className="text_error">{locale.msgs.INVALID_CODE}</div>);
            });

            // Calling setLoadState() after postWithCsrf() as it could throw an exception
            setLoadState(LoadState.LOADING);
            setErrorText("");
        }
        catch(e) {
            console.log(e);
        }
    }

    function handle2faCodeChange() {
        setErrorText("");
    }


    // RENDER:

    if(props.twoFactorType === TwoFactorAuthType.NONE) {
        return <NavigateSmart to="/collect_data/sensitive_data/" />;
    }

    return(
        <div id="two_factor_login">
            <TwoFactorAuth on2faCodeEntered={handle2faCodeEntered} on2faCodeChange={handle2faCodeChange}
                    twoFactorType={props.twoFactorType} nextSmsCountS={login.nextSmsCountS}
                    username={login.username} password={login.password} activation={true}
                    management={props.management} />

            { loadState === LoadState.LOADING ?
                <div className="loader margin_top_low"></div>
            :
                null
            }

            {errorText}
        </div>
    );
}
